import { render, staticRenderFns } from "./fillingQuestion.vue?vue&type=template&id=1c01966c&scoped=true"
import script from "./fillingQuestion.vue?vue&type=script&lang=js"
export * from "./fillingQuestion.vue?vue&type=script&lang=js"
import style0 from "./fillingQuestion.vue?vue&type=style&index=0&id=1c01966c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01966c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c01966c')) {
      api.createRecord('1c01966c', component.options)
    } else {
      api.reload('1c01966c', component.options)
    }
    module.hot.accept("./fillingQuestion.vue?vue&type=template&id=1c01966c&scoped=true", function () {
      api.rerender('1c01966c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/testquestion-manage/fillingQuestion.vue"
export default component.exports